/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media(max-width:991px){footer[_ngcontent-%COMP%]{height:0}a[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{font-size:10px}}@media(min-width:992px){#divEspacoNavbarMobile[_ngcontent-%COMP%]{display:none}footer[_ngcontent-%COMP%]{position:relative;bottom:0}svg[_ngcontent-%COMP%]{fill:#fff}}\n/*# sourceMappingURL=footer.component.css.map*/"];
export { styles as styles };
